import {makeAutoObservable, runInAction} from "mobx";

export class WithToggle {

    private _value = false

    constructor(initialValue = false) {
        makeAutoObservable(this)
        this._value = initialValue
    }

    get value() {
        return this._value
    }

    setTrue = () => {
        runInAction(() => {
            this._value = true
        })
    }

    setFalse = () => {
        runInAction(() => {
            this._value = false
        })
    }

    toggle = () => {
        runInAction(() => {
            this._value = !this._value
        })
    }
}